import HubertDialog from 'components/HubertUI/HubertDialog';
import CreateTemplate from 'components/Templates/builder/CreateTemplate/CreateTemplate';
import type { ComponentProps } from 'react';
import { useAppSelector } from 'rtk/query/hooks';
import styles from './styles.module.css';

type Props = ComponentProps<typeof HubertDialog>;

const CreateTemplateDialog = ({ ...props }: Props) => {
  const dialog = useAppSelector((state) => state.Layout.createTemplateDialog);

  const customContainer = document.getElementById('main-content') as HTMLElement;
  return (
    <HubertDialog {...props} open={dialog.show} modal={false}>
      <HubertDialog.Content
        position="right"
        portalContent={true}
        portalElement={customContainer}
        className={styles.CreateTemplateDialogContent}
      >
        <CreateTemplate
          key={JSON.stringify(dialog.data ?? {})}
          initialTemplate={dialog.data ?? undefined}
        ></CreateTemplate>
      </HubertDialog.Content>
    </HubertDialog>
  );
};

export default CreateTemplateDialog;
